module.exports = __webpack_public_path__ + "img/but_login_confirm.4f15fc2c.png";